import { cardCvc, cardExpiry, cardNumber } from './settings';

export function getInputErrorByCode(code: string): {
  name: string;
  error: string;
} | null {
  if (code === 'incomplete_number') {
    return { name: cardNumber, error: 'Incomplete card number' };
  }
  if (code === 'invalid_number') {
    return { name: cardNumber, error: 'Invalid card number' };
  }
  if (code === 'incomplete_expiry') {
    return { name: cardExpiry, error: 'Incomplete expiry' };
  }
  if (code === 'invalid_expiry_year') {
    return { name: cardExpiry, error: 'Incomplete expiry year' };
  }
  if (code === 'invalid_expiry_month_past') {
    return { name: cardExpiry, error: 'Incomplete expiry month past' };
  }
  if (code === 'invalid_expiry_year_past') {
    return { name: cardExpiry, error: 'Incomplete expiry year past' };
  }
  if (code === 'incomplete_cvc') {
    return { name: cardCvc, error: 'Incomplete code' };
  }
  if (code === 'card_declined') {
    return { name: cardNumber, error: 'Your card is not supported' };
  }
  if (code === 'setup_intent_authentication_failure') {
    return {
      name: cardNumber,
      error:
        'We are unable to authenticate your payment method. Try one more or choose a different payment method and try again.',
    };
  }

  return null;
}
